// Backend integration point: replace all mock data with API calls to your backend service

export type ConnectionType = 'Na lokaciji' | 'VPN' | 'VNC' | 'RDP' | 'AnyDesk' | 'TeamViewer';
export type InterventionStatus = 'Završena' | 'U toku' | 'Zakazana';
export type EquipmentType = 'Desktop' | 'Laptop' | 'Server' | 'Štampač' | 'Switch' | 'Ruter' | 'UPS' | 'Ostalo';

export interface Employee {
  id: string;
  name: string;
  position: string;
  phone: string;
  email: string;
}

export interface Equipment {
  id: string;
  clientId: string;
  type: EquipmentType;
  brand: string;
  model: string;
  serial: string;
  purchaseYear: number;
  notes: string;
}

export interface Client {
  id: string;
  name: string;
  pib: string;
  address: string;
  city: string;
  responsiblePerson: string;
  phone: string;
  email: string;
  employees: Employee[];
  notes: string;
  createdAt: string;
}

export interface Intervention {
  id: string;
  clientId: string;
  clientName: string;
  date: string;
  time: string;
  connectionType: ConnectionType;
  description: string;
  duration: number; // minutes
  status: InterventionStatus;
  equipmentId?: string;
  equipmentLabel?: string;
  notes: string;
}

export const CLIENTS: Client[] = [
  {
    id: 'client-001',
    name: 'Alfa Commerce d.o.o.',
    pib: '103456789',
    address: 'Bulevar Oslobođenja 45',
    city: 'Novi Sad',
    responsiblePerson: 'Marko Nikolić',
    phone: '+381 21 456 789',
    email: 'marko.nikolic@alfa-commerce.rs',
    notes: 'Prioritetni klijent. Servis svake srede.',
    createdAt: '2024-03-15',
    employees: [
      { id: 'emp-001-1', name: 'Marko Nikolić', position: 'Direktor', phone: '+381 63 123 456', email: 'marko.nikolic@alfa-commerce.rs' },
      { id: 'emp-001-2', name: 'Jelena Petrović', position: 'Računovođa', phone: '+381 64 234 567', email: 'jelena.petrovic@alfa-commerce.rs' },
      { id: 'emp-001-3', name: 'Stefan Jovanović', position: 'Magacioner', phone: '+381 65 345 678', email: 'stefan.j@alfa-commerce.rs' },
      { id: 'emp-001-4', name: 'Ana Marković', position: 'Prodavac', phone: '+381 66 456 789', email: 'ana.m@alfa-commerce.rs' },
    ],
  },
  {
    id: 'client-002',
    name: 'Tehnoprom d.o.o.',
    pib: '107654321',
    address: 'Industrijska zona bb',
    city: 'Subotica',
    responsiblePerson: 'Dragana Ilić',
    phone: '+381 24 567 890',
    email: 'dragana.ilic@tehnoprom.rs',
    notes: 'Servis po pozivu.',
    createdAt: '2024-06-01',
    employees: [
      { id: 'emp-002-1', name: 'Dragana Ilić', position: 'Direktor', phone: '+381 60 567 890', email: 'dragana.ilic@tehnoprom.rs' },
      { id: 'emp-002-2', name: 'Nemanja Stojanović', position: 'IT koordinator', phone: '+381 61 678 901', email: 'nemanja.s@tehnoprom.rs' },
    ],
  },
  {
    id: 'client-003',
    name: 'MediCare Klinika',
    pib: '109876543',
    address: 'Vojvođanska 12',
    city: 'Sremska Mitrovica',
    responsiblePerson: 'Dr. Milica Đorđević',
    phone: '+381 22 678 901',
    email: 'milica.djordjevic@medicare-klinika.rs',
    notes: 'Posebna pažnja — medicinski podaci. GDPR.',
    createdAt: '2024-09-10',
    employees: [
      { id: 'emp-003-1', name: 'Dr. Milica Đorđević', position: 'Direktor klinike', phone: '+381 62 789 012', email: 'milica.djordjevic@medicare-klinika.rs' },
      { id: 'emp-003-2', name: 'Ivana Lukić', position: 'Medicinska sestra', phone: '+381 63 890 123', email: 'ivana.l@medicare-klinika.rs' },
      { id: 'emp-003-3', name: 'Bojan Radić', position: 'Recepcionar', phone: '+381 64 901 234', email: 'bojan.r@medicare-klinika.rs' },
    ],
  },
  {
    id: 'client-004',
    name: 'AutoCenter Vukovic',
    pib: '112345678',
    address: 'Cara Lazara 88',
    city: 'Kragujevac',
    responsiblePerson: 'Zoran Vuković',
    phone: '+381 34 789 012',
    email: 'zoran@autocenter-vukovic.rs',
    notes: 'Godišnji ugovor o održavanju.',
    createdAt: '2025-01-20',
    employees: [
      { id: 'emp-004-1', name: 'Zoran Vuković', position: 'Vlasnik', phone: '+381 65 012 345', email: 'zoran@autocenter-vukovic.rs' },
      { id: 'emp-004-2', name: 'Milovan Tešić', position: 'Šef servisa', phone: '+381 66 123 456', email: 'milovan.t@autocenter-vukovic.rs' },
    ],
  },
  {
    id: 'client-005',
    name: 'Pravna kancelarija Simić',
    pib: '115678901',
    address: 'Kneza Miloša 7',
    city: 'Beograd',
    responsiblePerson: 'Advokat Petar Simić',
    phone: '+381 11 890 123',
    email: 'petar.simic@adv-simic.rs',
    notes: 'Stroga politika privatnosti.',
    createdAt: '2025-03-05',
    employees: [
      { id: 'emp-005-1', name: 'Advokat Petar Simić', position: 'Vlasnik', phone: '+381 67 234 567', email: 'petar.simic@adv-simic.rs' },
      { id: 'emp-005-2', name: 'Maja Filipović', position: 'Sekretar', phone: '+381 68 345 678', email: 'maja.f@adv-simic.rs' },
    ],
  },
  {
    id: 'client-006',
    name: 'EduCenter Pro',
    pib: '118901234',
    address: 'Školska 3',
    city: 'Niš',
    responsiblePerson: 'Gordana Vasić',
    phone: '+381 18 901 234',
    email: 'gordana.vasic@educenter-pro.rs',
    notes: 'Škola računara — 20+ radnih stanica.',
    createdAt: '2025-07-12',
    employees: [
      { id: 'emp-006-1', name: 'Gordana Vasić', position: 'Direktor', phone: '+381 69 456 789', email: 'gordana.vasic@educenter-pro.rs' },
      { id: 'emp-006-2', name: 'Aleksandar Pavlović', position: 'Instruktor', phone: '+381 60 567 890', email: 'aleksandar.p@educenter-pro.rs' },
      { id: 'emp-006-3', name: 'Tamara Đukić', position: 'Instruktor', phone: '+381 61 678 901', email: 'tamara.d@educenter-pro.rs' },
    ],
  },
];

export const EQUIPMENT: Equipment[] = [
  { id: 'eq-001', clientId: 'client-001', type: 'Desktop', brand: 'HP', model: 'ProDesk 600 G6', serial: 'CZC0421B7K', purchaseYear: 2021, notes: 'Računovodstvo' },
  { id: 'eq-002', clientId: 'client-001', type: 'Desktop', brand: 'Lenovo', model: 'ThinkCentre M75q', serial: 'PF2Q3XAB', purchaseYear: 2022, notes: 'Direkcija' },
  { id: 'eq-003', clientId: 'client-001', type: 'Server', brand: 'Dell', model: 'PowerEdge T40', serial: 'DMPX3Y2', purchaseYear: 2020, notes: 'Fileserver + backup' },
  { id: 'eq-004', clientId: 'client-001', type: 'Štampač', brand: 'Brother', model: 'HL-L2350DW', serial: 'E73932G4J123456', purchaseYear: 2023, notes: 'Kancelarija' },
  { id: 'eq-005', clientId: 'client-001', type: 'Switch', brand: 'Cisco', model: 'SG110-16', serial: 'FTX1234ABCD', purchaseYear: 2020, notes: 'Mrežni ormaran' },
  { id: 'eq-006', clientId: 'client-002', type: 'Server', brand: 'HPE', model: 'ProLiant ML30 Gen10', serial: 'CZJ1234567', purchaseYear: 2021, notes: 'ERP server' },
  { id: 'eq-007', clientId: 'client-002', type: 'Desktop', brand: 'Acer', model: 'Veriton X2690', serial: 'DTVRXEC00123', purchaseYear: 2022, notes: 'Magacin' },
  { id: 'eq-008', clientId: 'client-002', type: 'Laptop', brand: 'Dell', model: 'Latitude 5520', serial: 'BKPL123456', purchaseYear: 2022, notes: 'Menadžer' },
  { id: 'eq-009', clientId: 'client-003', type: 'Desktop', brand: 'HP', model: 'EliteDesk 800 G8', serial: 'CZC1234ABCD', purchaseYear: 2022, notes: 'Recepcija' },
  { id: 'eq-010', clientId: 'client-003', type: 'Štampač', brand: 'Canon', model: 'i-SENSYS MF453dw', serial: 'JVMB12345', purchaseYear: 2023, notes: 'Ordination' },
  { id: 'eq-011', clientId: 'client-003', type: 'UPS', brand: 'APC', model: 'Back-UPS 950VA', serial: '4B1234X56789', purchaseYear: 2021, notes: 'Server room' },
  { id: 'eq-012', clientId: 'client-004', type: 'Desktop', brand: 'Lenovo', model: 'IdeaCentre 3', serial: 'MP21234567', purchaseYear: 2023, notes: 'Kasa' },
  { id: 'eq-013', clientId: 'client-004', type: 'Ruter', brand: 'MikroTik', model: 'hEX S', serial: 'HEX123456789', purchaseYear: 2022, notes: 'Mrežna oprema' },
  { id: 'eq-014', clientId: 'client-005', type: 'Laptop', brand: 'Apple', model: 'MacBook Pro 14"', serial: 'C02X1234JYVX', purchaseYear: 2022, notes: 'Vlasnik' },
  { id: 'eq-015', clientId: 'client-005', type: 'Desktop', brand: 'HP', model: 'ProDesk 400 G7', serial: 'CZC2345BCDE', purchaseYear: 2023, notes: 'Sekretar' },
  { id: 'eq-016', clientId: 'client-006', type: 'Desktop', brand: 'Acer', model: 'Aspire TC-1660', serial: 'DTEBNEC001', purchaseYear: 2023, notes: 'Učionica 1 — 10 kom' },
  { id: 'eq-017', clientId: 'client-006', type: 'Switch', brand: 'TP-Link', model: 'TL-SF1024D', serial: 'TPLINK12345', purchaseYear: 2023, notes: 'Učionica 1' },
  { id: 'eq-018', clientId: 'client-006', type: 'Ruter', brand: 'Asus', model: 'RT-AX55', serial: 'ASUS1234567', purchaseYear: 2024, notes: 'WiFi' },
];

export const INTERVENTIONS: Intervention[] = [
  { id: 'int-001', clientId: 'client-001', clientName: 'Alfa Commerce d.o.o.', date: '2026-04-29', time: '14:30', connectionType: 'AnyDesk', description: 'Instalacija Windows 11 Pro na računaru direktora. Migracija korisničkih podataka sa starog diska. Aktivacija Office 365 licence.', duration: 90, status: 'Završena', equipmentId: 'eq-002', equipmentLabel: 'Lenovo ThinkCentre M75q', notes: 'Sve prošlo bez problema. Napravljen backup pre instalacije.' },
  { id: 'int-002', clientId: 'client-001', clientName: 'Alfa Commerce d.o.o.', date: '2026-04-28', time: '10:00', connectionType: 'Na lokaciji', description: 'Zamena HDD na serveru za SSD (Samsung 870 EVO 1TB). Konfiguracija RAID 1 niza. Test performansi.', duration: 180, status: 'Završena', equipmentId: 'eq-003', equipmentLabel: 'Dell PowerEdge T40', notes: 'Nabavka SSD-a na teret klijenta.' },
  { id: 'int-003', clientId: 'client-002', clientName: 'Tehnoprom d.o.o.', date: '2026-04-28', time: '08:30', connectionType: 'VPN', description: 'Konfiguracija VPN tunela za pristup ERP sistemu iz home office okruženja. Instalacija OpenVPN klijenta na 3 laptopa.', duration: 60, status: 'Završena', equipmentId: 'eq-006', equipmentLabel: 'HPE ProLiant ML30 Gen10', notes: '' },
  { id: 'int-004', clientId: 'client-003', clientName: 'MediCare Klinika', date: '2026-04-27', time: '16:00', connectionType: 'TeamViewer', description: 'Ažuriranje softvera za zakazivanje pacijenata (MedSoft v3.2.1). Rešavanje buga u modulu za fakturisanje.', duration: 45, status: 'Završena', equipmentId: 'eq-009', equipmentLabel: 'HP EliteDesk 800 G8', notes: 'Vendor potvrdio fix u sledećoj verziji.' },
  { id: 'int-005', clientId: 'client-001', clientName: 'Alfa Commerce d.o.o.', date: '2026-04-25', time: '11:15', connectionType: 'RDP', description: 'Podešavanje automatskog backup-a na NAS uređaj. Testiranje restore procedure. Kreiranje rasporeda backup-a (svaki dan u 23:00).', duration: 75, status: 'Završena', equipmentId: 'eq-003', equipmentLabel: 'Dell PowerEdge T40', notes: 'Backup testiran i verificiran.' },
  { id: 'int-006', clientId: 'client-004', clientName: 'AutoCenter Vukovic', date: '2026-04-24', time: '09:00', connectionType: 'Na lokaciji', description: 'Instalacija nove mrežne infrastrukture — zamena starog rutera MikroTik hEX S. Konfiguracija VLAN-ova za kancelariju i servis.', duration: 120, status: 'Završena', equipmentId: 'eq-013', equipmentLabel: 'MikroTik hEX S', notes: 'Kreiran dijagram mreže za klijenta.' },
  { id: 'int-007', clientId: 'client-005', clientName: 'Pravna kancelarija Simić', date: '2026-04-23', time: '13:00', connectionType: 'AnyDesk', description: 'Rešavanje problema sa Outlook-om — greška u sinhronizaciji Exchange servera. Rekonfiguracija profila, test slanja/primanja.', duration: 30, status: 'Završena', equipmentId: 'eq-014', equipmentLabel: 'Apple MacBook Pro 14"', notes: '' },
  { id: 'int-008', clientId: 'client-006', clientName: 'EduCenter Pro', date: '2026-04-22', time: '15:30', connectionType: 'Na lokaciji', description: 'Reinstalacija Windows 10 na 5 računara u učionici 1. Instalacija obrazovnog softvera (Office, GIMP, VS Code, AutoCAD LT).', duration: 240, status: 'Završena', equipmentId: 'eq-016', equipmentLabel: 'Acer Aspire TC-1660', notes: 'Korišćen batch skript za automatsku instalaciju.' },
  { id: 'int-009', clientId: 'client-002', clientName: 'Tehnoprom d.o.o.', date: '2026-04-21', time: '10:30', connectionType: 'VNC', description: 'Hitna intervencija — pad ERP servera usled pregrejavanja. Čišćenje servera, zamena termalne paste na CPU. Restart servisa.', duration: 90, status: 'Završena', equipmentId: 'eq-006', equipmentLabel: 'HPE ProLiant ML30 Gen10', notes: 'Preporučena ugradnja dodatnog ventilatora.' },
  { id: 'int-010', clientId: 'client-001', clientName: 'Alfa Commerce d.o.o.', date: '2026-04-18', time: '09:00', connectionType: 'Na lokaciji', description: 'Redovni mesečni servis — čišćenje računara, ažuriranje sistema, pregled antivirus nalaza, provera diska i memorije.', duration: 120, status: 'Završena', notes: '' },
  { id: 'int-011', clientId: 'client-003', clientName: 'MediCare Klinika', date: '2026-04-17', time: '14:00', connectionType: 'RDP', description: 'Konfiguracija novog korisničkog naloga za Dr. Lukića. Podešavanje dozvola pristupa, instalacija potrebnih aplikacija.', duration: 40, status: 'Završena', equipmentId: 'eq-009', equipmentLabel: 'HP EliteDesk 800 G8', notes: '' },
  { id: 'int-012', clientId: 'client-005', clientName: 'Pravna kancelarija Simić', date: '2026-04-16', time: '11:00', connectionType: 'TeamViewer', description: 'Migracija podataka sa starog računara na novi HP ProDesk. Prenos dokumenata, podešavanje programa za pravnu evidenciju.', duration: 150, status: 'Završena', equipmentId: 'eq-015', equipmentLabel: 'HP ProDesk 400 G7', notes: 'Stari računar deaktiviran.' },
  { id: 'int-013', clientId: 'client-004', clientName: 'AutoCenter Vukovic', date: '2026-04-15', time: '08:00', connectionType: 'AnyDesk', description: 'Podešavanje fiskalnog štampača — integracija sa POS sistemom. Test transakcija.', duration: 60, status: 'Završena', notes: 'POS sistem radi ispravno.' },
  { id: 'int-014', clientId: 'client-006', clientName: 'EduCenter Pro', date: '2026-04-14', time: '17:00', connectionType: 'VPN', description: 'Konfiguracija centralnog WiFi kontrolera. Optimizacija WiFi mreže u učionicama, test propusnog opsega.', duration: 75, status: 'Završena', equipmentId: 'eq-018', equipmentLabel: 'Asus RT-AX55', notes: '' },
  { id: 'int-015', clientId: 'client-001', clientName: 'Alfa Commerce d.o.o.', date: '2026-04-10', time: '10:00', connectionType: 'AnyDesk', description: 'Instalacija i konfiguracija novog štampača Brother HL-L2350DW. Driver instalacija, test štampe, podešavanje mrežnog štampanja.', duration: 45, status: 'Završena', equipmentId: 'eq-004', equipmentLabel: 'Brother HL-L2350DW', notes: '' },
  { id: 'int-016', clientId: 'client-002', clientName: 'Tehnoprom d.o.o.', date: '2026-04-08', time: '13:30', connectionType: 'Na lokaciji', description: 'Nadogradnja RAM memorije na 3 radne stanice (8GB → 16GB). Čišćenje kućišta, provera kablova.', duration: 90, status: 'Završena', notes: 'Nabavka RAM modula dogovorena unapred.' },
  { id: 'int-017', clientId: 'client-003', clientName: 'MediCare Klinika', date: '2026-04-05', time: '09:30', connectionType: 'Na lokaciji', description: 'Zamena UPS baterija. Test autonomije, kalibracija. Ažuriranje firmware-a UPS uređaja.', duration: 60, status: 'Završena', equipmentId: 'eq-011', equipmentLabel: 'APC Back-UPS 950VA', notes: 'Baterije nabavljene od klijenta.' },
  { id: 'int-018', clientId: 'client-001', clientName: 'Alfa Commerce d.o.o.', date: '2026-03-28', time: '11:00', connectionType: 'RDP', description: 'Rešavanje problema sa sporim pristupom deljenim folderima na serveru. Optimizacija SMB podešavanja, čišćenje starih permisija.', duration: 55, status: 'Završena', equipmentId: 'eq-003', equipmentLabel: 'Dell PowerEdge T40', notes: '' },
  { id: 'int-019', clientId: 'client-001', clientName: 'Alfa Commerce d.o.o.', date: '2026-03-20', time: '14:00', connectionType: 'Na lokaciji', description: 'Redovni mesečni servis mart — ažuriranja, antivirus, disk analiza, čišćenje.', duration: 120, status: 'Završena', notes: '' },
  { id: 'int-020', clientId: 'client-004', clientName: 'AutoCenter Vukovic', date: '2026-04-29', time: '16:00', connectionType: 'AnyDesk', description: 'Hitna intervencija — virus na kasa računaru. Čišćenje malware-a, reinstalacija Windows Defendera, full scan.', duration: 80, status: 'U toku', notes: 'Puna reinstalacija možda potrebna.' },
];

export function getClientById(id: string): Client | undefined {
  return CLIENTS.find(c => c.id === id);
}

export function getEquipmentByClient(clientId: string): Equipment[] {
  return EQUIPMENT.filter(e => e.clientId === clientId);
}

export function getInterventionsByClient(clientId: string): Intervention[] {
  return INTERVENTIONS.filter(i => i.clientId === clientId);
}

export function getInterventionsByPeriod(from: string, to: string): Intervention[] {
  return INTERVENTIONS.filter(i => i.date >= from && i.date <= to);
}

export const CONNECTION_TYPE_COLORS: Record<ConnectionType, { bg: string; text: string; dot: string }> = {
  'Na lokaciji': { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  'VPN':         { bg: 'bg-violet-50',  text: 'text-violet-700',  dot: 'bg-violet-500' },
  'VNC':         { bg: 'bg-orange-50',  text: 'text-orange-700',  dot: 'bg-orange-500' },
  'RDP':         { bg: 'bg-blue-50',    text: 'text-blue-700',    dot: 'bg-blue-500' },
  'AnyDesk':     { bg: 'bg-rose-50',    text: 'text-rose-700',    dot: 'bg-rose-500' },
  'TeamViewer':  { bg: 'bg-cyan-50',    text: 'text-cyan-700',    dot: 'bg-cyan-500' },
};

export const STATUS_COLORS: Record<InterventionStatus, { bg: string; text: string }> = {
  'Završena': { bg: 'bg-green-50', text: 'text-green-700' },
  'U toku':   { bg: 'bg-amber-50', text: 'text-amber-700' },
  'Zakazana': { bg: 'bg-blue-50',  text: 'text-blue-700' },
};

export const EQUIPMENT_TYPE_ICONS: Record<EquipmentType, string> = {
  'Desktop': 'Monitor',
  'Laptop': 'Laptop',
  'Server': 'Server',
  'Štampač': 'Printer',
  'Switch': 'Network',
  'Ruter': 'Wifi',
  'UPS': 'Zap',
  'Ostalo': 'Package',
};